export default __webpack_public_path__ + "static/media/jwportfolioSS-alpha.580d4e5b.png";